import { custom_post } from "../../utils/api";

export const generate_presigned_urls = async (exist_files:any, file_names: string[], selectedFiles: File[], props: any, type: any) => {
    console.log("Props:", props.module, file_names, props);
    
    const data = {
        bucketName: 'nautai-marine',
        folderName: props.module,
        fileNames: file_names,
    };

    try {
        const urls_resp: any = await custom_post(`s3PresignedUrls/${props.primary_id}`, data);
        let updated_files: any[] = [];

        console.log("URLs Response:", urls_resp);
        
        if (urls_resp && Array.isArray(urls_resp.urls) && urls_resp.urls.length > 0) {
            await Promise.all(selectedFiles.map(async (file: File, index: number) => {
                if (index < urls_resp.urls.length) {
                    console.log("******urls_resp*****", urls_resp)
                    const uploadUrl = urls_resp.urls[index].url;
                    const fileDetails = {
                        id: index + 1,
                        file_name: file.name,
                        type: file.type,
                        url: uploadUrl,
                        image_id:urls_resp.urls[index].image_id
                    };

                    const isUploaded = await uploadFileToS3(file, uploadUrl);
                    if (!isUploaded) {
                        console.error(`Failed to upload file: ${file.name}`);
                    }else{
                        updated_files.push(fileDetails);
                    }
                } else {
                    console.error("No URL available for file:", file.name);
                }
            }));

            if (type === 'edit') {

                let latest_files:any = [...exist_files, ...updated_files]
                props.onFileChange(latest_files);
            } else {
                return updated_files;
            }
        } else {
            console.error("No valid URLs returned from the API.");
        }
    } catch (error) {
        console.error("Error loading data:", error);
    }
};

const uploadFileToS3 = async (file: File, url: string): Promise<boolean> => {
    try {
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                "Content-Type": file.type,
            },
            body: file,
        });

        if (!response.ok) {
            console.error(`Failed to upload ${file.name}:`, response.status, response.statusText);
            return false;
        }
        console.log(`${file.name} uploaded successfully!`);
        return true;
    } catch (error) {
        console.error(`Error uploading ${file.name}:`, error);
        return false;
    }
};















// import { custom_post } from "../../utils/api";




// export const generate_presigned_urls = async (file_names: string[], selectedFiles: File[], props:any, type:any) => {
//     console.log("77777", props.module, file_names, props.primary_id)
//     const data = {
//         bucketName: 'tangent-private',
//         folderName: props.module,
//         fileNames: file_names,
//     };

//     try {
//         const urls_resp: any = await custom_post(`s3PresignedUrls/${props.primary_id}`, data);
//         let updated_files: any[] = [];
//         console.log("urls_resp", urls_resp);
//         if (urls_resp && Array.isArray(urls_resp.urls) && urls_resp.urls.length > 0) {
//             await Promise.all(selectedFiles.map(async (file: File, index: number) => {
//                 if (index < urls_resp.urls.length) {
//                     const uploadUrl = urls_resp.urls[index];
//                     let obj = {
//                         id: (index + 1),
//                         file_name: file.name,
//                         type: file.type,
//                         url: uploadUrl
//                     }
//                     updated_files.push(obj);
//                     await uploadFileToS3(file, uploadUrl);
//                 } else {
//                     console.error("No URL available for file:", file.name);
//                 }
//             }));
//             // Call onFileChange with updated files after all uploads are complete
//             if(type === 'edit'){
//                 props.onFileChange(updated_files);
//             }else{
//                 return updated_files;
//             }
           
//         } else {
//             console.error("No valid URLs returned from the API.");
//         }
//     } catch (error) {
//         console.error("Error loading data:", error);
//     }
// };

// const uploadFileToS3 = async (file: File, url: string) => {
//     try {
//         const response = await fetch(url, {
//             method: "PUT",
//             headers: {
//                 "Content-Type": file.type,
//             },
//             body: file,
//         });

//         if (!response.ok) {
//             throw new Error(`Failed to upload ${file.name} to S3`);
//         }
//         console.log(`${file.name} uploaded successfully!`);
//     } catch (error) {
//         console.error(`Error uploading ${file.name}:`, error);
//     }
// };